export default class pegLivenessPageDone extends HTMLElement {
	async connectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController = new AbortController();
		this.startTime = Date.now();
		this.countRetries = 0;

		this.#setEventListeners();
		this.#trackViewPage();
		this.#pollBackendStatus();
	}

	async disconnectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController.abort();
	}

	#setEventListeners() {
		this.querySelector('.reloadPage').addEventListener(
			'click',
			() => {
				this.#trackReloadPage();
				location.href = '/user/verification/liveness';
			},
			{ signal: this.abortController.signal },
		);

		this.querySelector('.callCustomerSupport').addEventListener(
			'click',
			() => {
				this.#trackClickHelp();
			},
			{ signal: this.abortController.signal },
		);
	}

	#pollBackendStatus() {
		this.#waitForEventBridgeResponse()
			.then((status) => {
				if (status === 'REDIRECT') {
					location.replace('/profile/welcomepage');
				} else if (status === 'REFRESHLIMITREACHED') {
					this.querySelector('.spinnerWrapper').remove();
					this.querySelector('.refreshLimitReachedWrapper').classList.remove('noDisplay');
				} else if (status === 'FAILED') {
					throw new Error('Failed to get a valid response from the backend after several retries.');
				}
			})
			.catch((error) => {
				jPar.util.log.error(error.toString(), 'page_method.pollBackendStatus.js EventBridge/status failed');
			});
	}

	async #waitForEventBridgeResponse() {
		// for debugging
		// backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: true, refreshLimitReached: false, cooldownTimeInSeconds: 5 });
		// backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: false, refreshLimitReached: false, cooldownTimeInSeconds: 5 });
		// backstageToolRwd.mockFetch.mockRequest('/user/verification/liveness/done/status?refreshCount=1', 'GET', { blocked: true, refreshLimitReached: true, cooldownTimeInSeconds: 5 });
		this.countRetries++;

		return fetchIt
			.get(`/user/verification/liveness/done/status?refreshCount=${this.countRetries}`)
			.then(async (data) => {
				if (data.refreshLimitReached) {
					return 'REFRESHLIMITREACHED';
				} else {
					if (data.blocked) {
						await jPar.util.awaitTimeout(parseInt(data.cooldownTimeInSeconds, 10) * 1000);
						return this.#pollBackendStatus();
					} else {
						return 'REDIRECT';
					}
				}
			})
			.catch(async (error) => {
				jPar.util.log.error(error.toString(), 'page_method.waitForEventBridgeResponse.js EventBridge/status failed');
				await jPar.util.awaitTimeout(5000); // Chance to have a selfhealing in the Backend
				return 'FAILED';
			});
	}

	#getElapsedSeconds() {
		return Math.round((Date.now() - this.startTime) / 1000);
	}

	#trackViewPage() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'liveness_verification_done',
			action: 'page_view',
		});
	}

	#trackReloadPage() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'liveness_verification_done',
			action: 'click',
			targetId: 'click_link_retry',
			cd2: this.#getElapsedSeconds(), // time_in_seconds from start of the page to clicking the retry link
			cd3: this.countRetries,
		});
	}

	#trackClickHelp() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'livenessPageDone',
			action: 'click',
			targetId: 'click_button_support',
			cd2: this.#getElapsedSeconds(), // time_in_seconds from start of the page to clicking the help button
			cd3: this.countRetries,
		});
	}
}
